import React, { useEffect, useState } from 'react';
import './CSS/Bootstrap/bootstrap.css';
import './CSS/style.css';
import * as RO from './Javascript/ReportObjects';
import { sortAndAssignRowIncident, assignStatusAndWeaponIncident } from './Javascript/IncidentsReport';
import { get_incident_data } from './Javascript/AnalyseRoute';

interface Props {
    route_data: RO.report_info | null;
    parsedIncidents: RO.RouteIncident[] | null;
    incidentsListTitle: string | null;
}

const RouteIncidents: React.FC<Props> = ({route_data, parsedIncidents, incidentsListTitle}) => {
    const [is_loading, set_is_loading] = useState(true);
    const [include, setInclude] = useState(false);
    const [incident_data, setIncidentData] = useState<RO.RouteIncident[] | null>(null);
    const [incident_title_metrics, set_incident_title_metrics] = useState(incidentsListTitle);
    useEffect(() => {
        const fetchData = async () => {
            try{
                if(include && route_data && incident_data == null && !parsedIncidents){
                    const res = await get_incident_data(route_data);
                    setIncidentData(res[0]);
                    set_incident_title_metrics(res[1] + "" + res[2] + " of route in last "+res[3]+" months");
                }else if(parsedIncidents && incident_data == null){
                    setIncidentData(assignStatusAndWeaponIncident(parsedIncidents));
                    setInclude(true);
                }
            } catch (error) {
                console.error(error);
            } finally {
                if(incident_data){
                    set_is_loading(false);
                }
            }
        };
    fetchData();
    }, [incident_data]);

    const displayValue = (value: any) => {
            return value !== null && value !== undefined && value !== '' && value != 'Unknown'? value : 'UNKNOWN';
    };

    return (
        <div>
        {include && (
        <div id="incident_reports_container">

            {is_loading ? (
                    <p> Finding Incidents... </p>
                ) : (incident_data === null || incident_data === undefined || incident_data.length === 0) ? (
                    <p>No incidents found within { incident_title_metrics ?? 'set distance'} of route</p>
                ) : (
                <>
                    <div className="report_row route_incident_reports_header">
                        <div className="inner_padding">
                            {parsedIncidents ? (
                                <h2>Incidents List</h2>
                            ):(
                                <h2>Incidents within { incident_title_metrics ?? 'set distance and timeframe'} </h2>
                            )}
                        </div>
                    </div>
                    {Object.entries(incident_data).map(([index, incident_data], _,array) => (
                    <>
                        <div className={`report_row route_incident_reports`}
                          style={parseInt(index) === 0 || parseInt(index) === 1 ? { minHeight: '290px' } : {}} key={index}>
                            <div className="inner_padding">

                                <div className="incident_details_cont col-8">
                                    <p className="sub_title">Incident { displayValue(incident_data.row) } Details</p>
                                    <table>
                                    <tbody>
                                        <tr>
                                            <td className="col-3"><span className="title">Lat</span> <br /> { displayValue(incident_data.incident_coordinates?.dec?.lat) }</td>
                                            <td className="col-3"><span className="title">Lng</span> <br /> { displayValue(incident_data.incident_coordinates?.dec?.lon) }</td>
                                            <td className="col-6"><span className="title">UTC Date & Time</span> <br /> { displayValue(incident_data.utc_date_time?.replace("T", " ") ) }</td>
                                        </tr>
                                        <tr>
                                            <td className="col-3"><span className="title">Ocean / Sea</span> <br /> { displayValue(incident_data.sea) }</td>
                                            <td className="col-3"><span className="title">Time of Day</span> <br /> { displayValue(incident_data.time_of_day) }</td>
                                            <td className="col-6"><span className="title">Local Date & Time</span> <br /> { displayValue(incident_data.local_date_time?.replace("T", " ")) }</td>
                                        </tr>
                                        <tr>
                                            <td className="col-6"><span className="title">Status</span> <br /> { displayValue(incident_data.incident_status) }</td>
                                            <td className="col-6"><span className="title">Weapons</span> <br /> { displayValue(incident_data.incident_weapons ) }</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>

                                <div className="victim_details_cont col-4">
                                    <p className="sub_title">Victim Details</p>
                                    <table>
                                    <tbody>
                                        <tr>
                                            <td className="col-4"><span className="title">Name</span> <br /> { displayValue(incident_data.victim_vessel_name) }</td>
                                            <td className="col-4"><span className="title">IMO</span> <br /> { displayValue(incident_data.victim_vessel_imo) }</td>
                                            <td className="col-4"><span className="title">MMSI</span> <br /> { displayValue(incident_data.victim_vessel_mmsi) }</td>
                                        </tr>
                                        <tr>
                                            <td className="col-4"><span className="title">Type</span> <br /> { displayValue(incident_data.victim_vessel_type) }</td>
                                            <td className="col-4"><span className="title">Status</span> <br /> { displayValue(incident_data.victim_vessel_status) }</td>
                                            <td className="col-4"><span className="title">Flag</span> <br /> { displayValue(incident_data.victim_vessel_flag?.name ) }</td>
                                        </tr>
                                        <tr>
                                            <td className="col-4"><span className="title">Length / Breadth (m)</span> <br /> { displayValue(incident_data.dimension ) }</td>
                                            <td className="col-4"><span className="title">Gross Tonnage</span> <br /> { displayValue(incident_data.victim_vessel_gross_tonnage ) }</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>

                                <div className="narration_details_cont col-8">
                                    <p className="sub_title">Narration</p>
                                    <p className="text"> { displayValue(incident_data.narration) }</p>
                                </div>
                                <div className="aggressor_details_cont col-4">
                                    <p className="sub_title">Aggressor Details</p>
                                    <table>
                                    <tbody>
                                        <tr>
                                            <td className="col-4"><span className="title">Number of Individuals</span></td>
                                            <td className="col-8">{ displayValue(incident_data.attacker_count) }</td>
                                        </tr>
                                        <tr>
                                            <td className="col-4"><span className="title">Description of Vessel</span></td>
                                            <td className="col-8">{ displayValue(incident_data.pirate_vessel_description) }</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {
                            parseInt(index) !== array.length - 1 && <div className="front_incident_border"></div>
                        }
                    </>
                    ))}
                </>
            )}
            </div>
        )}
        </div>
    );
};

export default React.memo(RouteIncidents);